var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['check-box']},[(_vm.showBox)?_c('span',{class:['box', { 'is-checked': _vm.checked, 'is-part-checked': _vm.indeterminate, 'is-disabled': _vm.disabled }],on:{"click":_vm.onChecked}}):_vm._e(),_c('div',{on:{"click":_vm.onSingleChecked,"dblclick":_vm.onDBLChecked}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }